import * as React from 'react';
import TreeNode from '../../models/TreeNode';
import Event from '../../models/project/Event';

class EventTable extends React.Component<{
  events: TreeNode[]
}, {}> {
  constructor(props) {
    super(props);
  }

  public render() {
    const eventRows = this.props.events.map((event, index) => {
      return <tr key={"row-" + index.toString()}>
        <td>{event.name}</td>
        <td>{event.parent}</td>
        <td>{event.component.title}</td>
        <td>{event.component.outcomes}</td>
        <td>"{event.outcome}"</td>
        <td>{event.probability}</td>
        <td>{event.work_estimate.map(e => e.toString(10)).getOrElse("null")}</td>
        <td>{event.custom_estimate.map(e => e.toString(10)).getOrElse("null")}</td>
        <td>unresolved</td>
        <td><button className="btn btn-outline-success btn-sm">Resolve</button></td>
      </tr>
    });

    return (
      <React.Fragment>
        <h2>Event outcomes</h2>
        <table className="table table-striped table-borderless">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Parent</th>
              <th scope="col">Event</th>
              <th scope="col">Outcome type</th>
              <th scope="col">Outcome</th>
              <th scope="col">Probability</th>
              <th scope="col">Work estimate</th>
              <th scope="col">Custom estimate</th>
              <th scope="col">Status</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {eventRows}
          </tbody>
        </table>
      </React.Fragment>
    );
  }
}

export default EventTable;



// WEBPACK FOOTER //
// ./src/components/eventtable/EventTable.tsx